import React from "react";
import DeviceAndTime from "./DeviceAndTime";
import ValueWithLabel, { labelWithSubscript, formattedValue } from "./ValueWithLabel";

export default function NBIoTTemphumidMeter(props) {
  const { aggregate: { values = [] } } = props;
  const [temperature, humidity, battery, signal] = values;
  return (
    <div className="absolute-container">
      <DeviceAndTime {...props} />
      <div className="temphumid-data">
        <div className="values-column">
          <ValueWithLabel label={labelWithSubscript("T", "end")} className="temphumid-t">
            <div>{formattedValue(temperature, 1, "°")}</div>
          </ValueWithLabel>
          <ValueWithLabel label={labelWithSubscript("H", "end")} className="temphumid-h">
            <div>{formattedValue(humidity, 1, "%")}</div>
          </ValueWithLabel>
        </div>
        <div className="values-column">
          <ValueWithLabel label={labelWithSubscript("RSSI", "")}>
            <div>{formattedValue(signal, 0, "dBm")}</div>
          </ValueWithLabel>
          <ValueWithLabel label={labelWithSubscript("Batt ", "")}>
            <div>{formattedValue(battery, 2, "V")}</div>
          </ValueWithLabel>
        </div>
      </div>
    </div>
  );
}
